import { gsap } from 'gsap';

export default function spmenuInit() {

  let
    html = document.getElementsByTagName('html')[0],
    button = document.querySelector('.js__menu-button'),
    menu = document.querySelector('.js__sp-menu'),
    list = document.querySelector('.js__sp-menu-list'),
    closebutton = document.querySelector('.js__close-button'),
    flag = false;


  console.log(html);
  console.log(button);
  console.log(menu);
  console.log(list);
  console.log(closebutton);

  function open() {
    flag = true;
    html.style.overflow = "hidden";
    html.style.height = "100%";
    gsap.set(menu, { display: "block" });
    gsap.fromTo(menu, { scale: 0.9, autoAlpha: 0 }, { scale: 1, autoAlpha: 1, duration: 0.3, ease: "power1.out" });
    gsap.fromTo(list.children, { y: 30, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: "power3.out", stagger: 0.1, delay: 0.3 });
    gsap.fromTo(closebutton, { autoAlpha: 0, }, { autoAlpha: 1, ease: "power3.out", duration: 1, delay: 0.5 });
    gsap.fromTo(closebutton, { scale: 0 }, { scale: 1, ease: "back.out(2)", duration: 0.4, delay: 0.7 });
  }

  function close() {
    console.log("close");
    flag = true;
    html.style.overflow = "";
    html.style.height = "";
    gsap.fromTo(list.children, { y: 0, autoAlpha: 1 }, { y: 30, autoAlpha: 0, ease: "power3.out", duration: 0.4, stagger: 0.02 });
    gsap.fromTo(menu, { scale: 1, autoAlpha: 1, display: "block" }, { autoAlpha: 0, delay: 0.3, display: "none", scale: 0.9, duration: 0.3, ease: "power1.out" });
  }

  button.addEventListener('click', function (e) {
    e.preventDefault();
    if (flag == true) return false;
    [button, closebutton, menu].map((x) => {
      x.classList.add('is-active');
    });
    open();
    flag = false;
    return false;
  });

  closebutton.addEventListener('click', function (e) {
    e.preventDefault();
    if (flag == true) return false;
    [button, closebutton, menu].map((x) => {
      x.classList.remove('is-active');
    });
    close();
    flag = false;
    return false;
  });

}